import httpManager from "@/app/shared/utils/httpManager";

export async function pushTypificationToPortfolio(portfolioId, typificationTree) {
  const response = await httpManager.post(
    `/entities/portfolios/${portfolioId}/tree_tipificactions/`,
    { groups: typificationTree }
  );
  return response.data;
}
